import {ProfileImage} from './profile-image';
import {Model} from './model';

export class Person implements Model {
  id: number;
  user_id: number;
  first_name: string;
  last_name: string;
  email: string;
  gender: string;
  date_of_birth: string;
  created_at: Date;
  updated_at: Date;
  profile_image: ProfileImage = new ProfileImage('/assets/images/unknown.png');

  show: boolean;

  constructor(data?) {
    if (data != null) {
      this.fill(data);
    }
  }

  public fill(data) {
    this.id            = data['id'];
    this.first_name    = data['first_name'];
    this.last_name     = data['last_name'];
    this.email         = data['email'];
    this.gender        = data['gender'];
    this.date_of_birth = data['date_of_birth'];
    this.created_at    = data['created_at'];
    this.updated_at    = data['updated_at'];
    if (data['profile_image'] && data['profile_image']['url']) {
      this.profile_image = data['profile_image'];
    }
  }

  public serialize() {
    return this;
  }

  public name() {
    // TODO: Trim values or only show one or the other
    return this.first_name + ' ' + this.last_name;
  }

}
